import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AiChatService } from '@app/core/services/ai-chat.service';
import { AiChatItem } from '@app/core/services/ai-chat.types';
import { Observable } from 'rxjs';

@Component({
    selector: 'tt-ai-chat-conversation-list',
    templateUrl: './ai-chat-conversation-list.component.html',
    styleUrls: ['./ai-chat-conversation-list.component.css'],
    standalone: false,
})
export class AiChatConversationListComponent {
    public readonly providerNamesByKeyno$: Observable<Record<string, string>> = this.aiChat.providerNamesByKeyno$;

    @Input()
    public chats: AiChatItem[] = [];

    @Input()
    public selectedChat?: AiChatItem;

    @Input()
    public loading = false;

    @Output()
    public chatSelected = new EventEmitter<AiChatItem>();

    constructor(private aiChat: AiChatService) {}

    public trackChat(_index: number, chat: AiChatItem): string {
        return chat.ai_chat_keyno;
    }
}
